import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isfetching: false,
  reportPartsData: [],
  isSuccess: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionConstants.ADD_REPORT_PARTS:
      return {
        ...state,
        reportPartsData: [...state.reportPartsData, action.payload],
        isfetching: false,
        isSuccess: true
      };
    default:
      return state;
  }
};
